<template>
  <div>
    <div
      v-for="(item, index) in mainList"
      :key="index"
      class="expense-item">
      <flexbox class="expense-item-head">
        <div class="expense-item-head-title">行程明細（{{ index+1 }}）</div>
        <i
          v-if="index != 0"
          class="el-icon-delete expense-item-head-delete"
          @click="deleteItems(index)"/>
      </flexbox>
      <flexbox
        wrap="wrap"
        align="stretch"
        class="clauses">
        <flexbox-item
          v-for="(subItem, subIndex) in showItems"
          :span="1/2"
          :key="subIndex"
          class="clauses-item">
          <div class="clauses-item-title">
            {{ subItem.name }}
          </div>
          <el-date-picker
            v-if="subItem.form_type == 'datetime'"
            v-model="item[subItem.field]"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="選擇日期"
            @change="valueChange"/>
          <el-select
            v-else-if="subItem.form_type == 'select'"
            v-model="item[subItem.field]"
            placeholder="請選擇"
            @change="valueChange">
            <el-option
              v-for="(item, index) in subItem.data"
              :key="index"
              :label="item"
              :value="item"/>
          </el-select>
          <el-input
            v-else
            v-model="item[subItem.field]"
            @input="calculateValueChange(index, subIndex)"/>
        </flexbox-item>
      </flexbox>
      <div class="description">
        <div class="description-title">備註</div>
        <el-input
          v-model="item['description']"
          :rows="3"
          type="textarea"
          resize="none"
          @input="valueChange"/>
      </div>
    </div>
    <div class="handle-bar">
      <el-button
        class="handle-bar-button"
        type="text"
        icon="el-icon-plus"
        @click="addItems(index)">新增事項</el-button>
        <!-- <div class="handle-bar-total">
        總時長：<span>{{totalDuration}}</span>
      </div> -->
    </div>
  </div>
</template>
<script type="text/javascript">
import objMixin from '@/components/CreateCom/objMixin'

export default {
  name: 'XhLeaves', // 請假事項
  components: {},
  mixins: [objMixin],
  props: {},
  data() {
    return {
      mainList: [],
      imageIndex: -1,
      totalDuration: '0', // 合計
      showItems: [
        {
          field: 'vehicle',
          name: '交通工具',
          form_type: 'select',
          data: ['飛機', '火車', '汽車', '其他']
        },
        {
          field: 'trip',
          name: '單程往返',
          form_type: 'select',
          data: ['單程', '往返']
        },
        {
          field: 'start_address',
          name: '出發城市',
          form_type: 'text'
        },
        {
          field: 'end_address',
          name: '目的城市',
          form_type: 'text'
        },
        {
          field: 'start_time',
          name: '開始時間',
          form_type: 'datetime'
        },
        {
          field: 'end_time',
          name: '結束時間',
          form_type: 'datetime'
        },
        {
          field: 'duration',
          name: '時長（天）',
          form_type: 'text'
        }
      ]
    }
  },
  computed: {},
  watch: {
    value: function(val) {
      this.dataValue = val
      if (val.list && val.list.length > 0) {
        this.mainList = val.list
      } else {
        this.mainList.push(this.getValueItem())
      }
    }
  },
  mounted() {
    if (this.dataValue.list && this.dataValue.list.length > 0) {
      this.mainList = this.dataValue.list
    } else {
      this.mainList.push(this.getValueItem())
    }
  },
  methods: {
    deleteItems(index) {
      this.mainList.splice(index, 1)
    },
    addItems() {
      this.mainList.push(this.getValueItem())
    },
    valueChange() {
      this.submitValueChange(false)
    },
    // 值更新的回撥
    calculateValueChange(mainIndex, subIndex) {
      if (subIndex < 5) {
        this.submitValueChange(false)
        return
      }
      var total = 0
      for (let index = 0; index < this.mainList.length; index++) {
        const element = this.mainList[index]
        total = total + parseFloat(element.duration ? element.duration : 0)
      }
      this.totalDuration = total

      this.submitValueChange(true)
    },
    submitValueChange(update) {
      this.$emit('value-change', {
        index: this.index,
        value: {
          list: this.mainList,
          update: update, // 是否更新總數
          duration: this.totalDuration
        }
      })
    },
    getValueItem() {
      return {
        vehicle: '',
        trip: '',
        start_address: '',
        end_address: '',
        start_time: '',
        end_time: '',
        duration: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.expense-item {
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  &-head {
    padding: 10px 20px;
    background-color: #f5f5f5;
    &-title {
      height: auto;
      font-size: 12px;
      color: #333;
      flex: 1;
      line-height: normal;
    }

    &-delete {
      padding: 0 10px;
      color: #ffd700;
      font-size: 14px;
    }
  }
}

.clauses {
  padding: 10px 10px;
  &-item {
    margin-left: 0 !important;
    display: flex;
    padding: 0 10px;
    &-title {
      width: 90px;
      flex-shrink: 0;
      font-size: 12px;
      color: #333;
    }
  }
}

.sub-total {
  font-size: 12px;
  color: #333;
}

.description {
  padding: 0 20px;
  &-title {
    font-size: 12px;
    color: #333;
  }
}

.el-input ::v-deep .el-input__inner {
  border-color: #ddd !important;
}

.el-select ::v-deep .el-input__inner {
  border-color: #ddd !important;
}

.el-textarea ::v-deep .el-textarea__inner {
  border-color: #ddd !important;
}

.handle-bar {
  padding: 0 20px;
  height: 29px;
  &-button {
    float: right;
    border: none;
    color: #ffd700;
  }
  &-total {
    margin-top: 10px;
    text-align: left;
    font-size: 13px;
    color: #333;
    span {
      color: #666;
    }
  }
}
</style>
